import type {CSSProperties} from 'react';

export type WedgeBlipCoinLook = 'blip-coin' | 'blip-nudge-open';

const BLIP_COIN_LOOKS = new Set<string>(['blip-coin', 'blip-nudge-open']);
export const isWedgeBlipCoinLook = (look: string): look is WedgeBlipCoinLook => BLIP_COIN_LOOKS.has(look);

/* Released Blip launcher (Wedge): the floating coin and the open button inside the intro pill. Each reads the exact legacy declarations, in the
   order of the source. The caller owns the glyph, the label, the handlers (press, hover, tilt, focus ring) and the placement.
   Coin is the bare 52px round button that holds the coin art: absolute, no padding, no border, a transparent fill, the pointer, a 2px transparent
   outline held 3px out (the focus handler of the caller paints it) and no tap highlight. The caller sets the right and bottom offsets, the
   stacking order and the entrance animation, which change with the screen.
   Nudge open is the bare two-line text button inside the pill: a column that starts at the left, a 1px gap, no border, fill or padding, inherited
   type, left text and the pointer. No look draws a transparent target (the `blip-` hit rule removes it). */
const COIN = 52;

export function wedgeBlipCoinStyle(look: WedgeBlipCoinLook): CSSProperties {
  if (look === 'blip-coin') return {
    position: 'absolute', width: COIN, height: COIN, padding: 0, borderRadius: 999, border: 'none', background: 'transparent',
    cursor: 'pointer', outline: '2px solid transparent', outlineOffset: 3, WebkitTapHighlightColor: 'transparent',
  };
  return {
    display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, border: 'none', background: 'transparent', padding: 0, margin: 0,
    font: 'inherit', textAlign: 'left', cursor: 'pointer', WebkitTapHighlightColor: 'transparent',
  };
}
